export enum ModalResponse {
  OK = 'OK',
  CANCEL = 'CANCEL',
  CLOSE = 'CLOSE',
}
